import { call, put, takeLatest } from "redux-saga/effects";
import { GetUserDeviceRegistrationServiceInit, 
    GetUserDeviceRegistrationServiceSuccess, 
    GetUserDeviceRegistrationServiceFailure } from "./UserDeviceRegistrationSlice";
import { _CALLGETAPI } from "../../api/apiHandler";
import { getLocalSessionData, storeUserDeviceRegistration } from "../../utils/Authentication/handleUserSession";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from "../../constants/AppConstants";
import { handleError } from "../SagaError";
import i18next from "i18next";

function _USERDEVICEREGISTRATIONSERVICE(userId, deviceId) {
    const endpoint = _API_ENDPOINT.GET_USER_DEVICE_REGISTRATION_TYPE;
      const payload = {
          params: {
              'userId': userId,
              'deviceId': deviceId
          }
      }
      return _CALLGETAPI(endpoint, payload)
      .then(response => {
          return response;
      })
      .catch((error) => {
          throw error;
      });
}

function* handleUserDeviceRegistrationService(){
    try {
        const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
        const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
        const userDeviceRegistrationInfo = yield call(_USERDEVICEREGISTRATIONSERVICE, userId, deviceId);
        storeUserDeviceRegistration(userDeviceRegistrationInfo);

        (userDeviceRegistrationInfo.actionStatus.toUpperCase() === SUCCESS)
        ? yield put(GetUserDeviceRegistrationServiceSuccess(userDeviceRegistrationInfo))
        : yield* handleError(GetUserDeviceRegistrationServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"));
    }
    catch (error) {
        yield* handleError(GetUserDeviceRegistrationServiceFailure, error.message);
    }
}

export default function* watchGetUserDeviceRegistrationService() {
    yield takeLatest(GetUserDeviceRegistrationServiceInit.type, handleUserDeviceRegistrationService);
}